import script from "./dataHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./dataHistory.vue?vue&type=script&setup=true&lang=js"

import "./dataHistory.vue?vue&type=style&index=0&id=07f1e1b5&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f1e1b5"]])

export default __exports__